import React, { useState } from "react";
import AJXLoader from "@components/AJXLoader";
import LoadError from "@components/LoadError";
import { apiSend, getRoute } from "@services/axios";
import { useTranslation } from "react-i18next";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import Activity from "./components/Activity";
import Form from "react-bootstrap/Form";
import { useParams } from "react-router-dom";
import IBreadcrumb from "@components/IBreadcrumb";
import { Config } from "@config/config";
import FormUser from "./forms/FormUser";
import { generatePassword } from "./Action";

const queryClient = new QueryClient();
const Profile = (props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <LoadUserProfile {...props} />
    </QueryClientProvider>
  );
};

export default Profile;
function LoadUserProfile(props) {
  const { t } = useTranslation();
  const id = useParams().id;
  const [loading, setLoading] = useState(false);
  const { isLoading, error, data } = useQuery("repoData", () =>
    apiSend([getRoute("USER_RETRIEVE"), id].join("/"), "get")
  );
  if (isLoading) return <AJXLoader />;
  if (error) return <LoadError message={t("not_found")} />;
  if (data?.data?.request?.status !== true) {
    return <LoadError message={t("not_found")} />;
  }
  const user = data?.data?.result;
  const config = new Config();

  var items = [
    {
      href: "/",
      title: config.icon("home", 18, 0.9),
    },
    {
      href: "/users",
      title: (
        <>
          {config.icon("users", 18, 0.9)}
          <span>{t("users")}</span>
        </>
      ),
    },
    {
      title: user.full_name,
    },
  ];

  return (
    <>
      <IBreadcrumb items={items} />
      <Form as="div" className="container">
        <Form as="div" className="row">
          <Form className="col-md-7  ">
            <Form as="div" className="bg-white px-3 mb-3 pb-3 border h-100">
              <FormUser user={user} t={t} />
            </Form>
          </Form>
          <Form as="div" className="col-md-5 ps-md-4 ">
            <Form
              as="div"
              className="bg-white px-3 mb-3 pb-3 border h-100 container-hv"
            >
              <Form
                as="button"
                type="submit"
                className="btn-blue p-3 rounded-3 fw-bold w-100 m-3"
                onClick={() => generatePassword(id, setLoading)}
              >
                {loading ? (
                  <Form
                    as="span"
                    className="spinner-border spinner-border-sm m-1 "
                  ></Form>
                ) : (
                  t("generate_password")
                )}
              </Form>
            </Form>
          </Form>
          <Form as="div" className="col-md-12  ">
            <Form as="h3" className="m-3">
              {t("your_activity")}
            </Form>
            <Activity userId={id} data={user.sessionLog} />
          </Form>
        </Form>
      </Form>
    </>
  );
}
